import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function PrivateRoute({ children }) {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) return <div className="route-fallback">Checking access…</div>;
  if (!currentUser) return <Navigate to="/auth" replace state={{ from: location.pathname }} />;

  return children;
}
